import { NavRoute } from 'types/custom';
import { FillingStatementsSectionKey } from 'models/statements';
import terms from 'i18n';

export const fillingStatementsRoutes: NavRoute<FillingStatementsSectionKey>[] =
  [
    {
      to: 'exam-results',
      title: terms.UNIFIED_EXAMS,
      text: terms.UNIFIED_EXAMS_TEXT,
      key: 'examResults',
      status: 'not visited',
    },
    {
      to: 'achievements',
      title: terms.ACHIEVEMENTS,
      text: terms.ACHIEVEMENTS_TEXT,
      key: 'achievements',
      status: 'not visited',
    },
    {
      to: 'privileges',
      title: terms.PRIORITY_ENROLLMENT,
      text: terms.PRIORITY_ENROLLMENT_TEXT,
      key: 'privileges',
      status: 'not visited',
    },
    {
      to: 'priority-rights',
      title: terms.PRIORITY_RIGHTS,
      text: terms.PRIORITY_RIGHTS_TEXT,
      key: 'priorityRights',
      status: 'not visited',
    },
    {
      to: 'target',
      title: 'Целевой договор',
      text: 'Заполните раздел, если у Вас есть договор о целевом обучении',
      key: 'target',
      status: 'not visited',
    },
    {
      to: 'directions',
      title: terms.DIRECTIONS_TRAINING,
      text: '',
      key: 'directions',
      status: 'not visited',
    },
    {
      to: 'test',
      title: terms.ENTRANCE_EXAMS,
      text: terms.ENTRANCE_EXAMS_TEXT,
      key: 'test',
      status: 'not visited',
    },
    {
      to: 'contract',
      title: terms.CONTRACT,
      text: terms.CONTRACT_TEXT,
      key: 'contract',
      status: 'not visited',
    },
    {
      to: 'consent',
      title: terms.INFORMING_AND_AGREEMENTS,
      text: terms.INFORMING_AND_AGREEMENTS_TEXT,
      key: 'consent',
      status: 'not visited',
    },
    {
      to: 'agreement',
      title: terms.AGREEMENT,
      text: '',
      key: 'agreement',
      status: 'not visited',
    },
    {
      to: 'blank',
      title: terms.FORMS_OF_DOCUMENTS,
      text: terms.FORMS_OF_DOCUMENTS_TEXT,
      key: 'blank',
      status: 'not visited',
    },
  ];
